export const DEFAULT_AUTOCOMPLETE_URL = '/rest/greenhopper/1.0/sprint/picker?query=';
export const MAX_ACTIVE_SPRINTS = 5;
export const MAX_RESULTS = 10;
